import React, { useState } from "react";

// libarry and framework
import _ from "lodash";
import { Button, Spinner } from "react-bootstrap";
import { useMutation } from "@apollo/client";
import { useToasts } from "react-toast-notifications";

//component
import { JOINT_ALL_ORDER_GROUP } from "../../../graphql/orderGroup/mutation";
import ModalConfirmComponent from "../../ModalConfirmComponent";

// icons 
import {
    MdChecklist
} from "react-icons/md";

function BtnJointAllOrderGroup({ setIsFetch, orderGroupSelect, setIsSelectAll, setOrderGroupDownload, setSelectedIds}) {
    const { addToast } = useToasts();
    const [isConfirm, setIsConfirm] = useState(false)
    // TODO CALL API JOINT_ORDER
    const [jointAllOrderGroup, { loading: jointAllOrderGroupLoading }] = useMutation(JOINT_ALL_ORDER_GROUP);

    const validateJointOrderGroup = async ({ orderGroups }) => {
        try {
            if (jointAllOrderGroupLoading) return;
            const _variables = {
                variables: {
                    where: {
                        orderGroups: JSON.stringify(orderGroups),
                    },
                },
            };
            // TODO: call api joint order
            const response = await jointAllOrderGroup(_variables);
            if (_.isEmpty(response?.error)) {
                addToast("ລວມອໍເດີ ສຳເລັດ", {
                    appearance: "success",
                    autoDismiss: true,
                    timer: 3000,
                });
            setIsConfirm(false);
            setIsFetch(true);
            setIsSelectAll(false);
            setOrderGroupDownload([]);
            setSelectedIds([]);

            } else {
                addToast("ລວມອໍເດີ ຫລົ້ມເຫລວ!!", {
                    appearance: "error",
                    autoDismiss: true,
                    timer: 3000,
                });
            }
        } catch (error) {
            // console.log("joint order failed error: ", error);
            addToast("ລວມອໍເດີ ຫລົ້ມເຫລວ!", {
                appearance: "warning",
                autoDismiss: true,
            });
            setIsConfirm(false)
        }
    }

    return (
        <>

            <Button
                variant="light"

                disabled={
                    orderGroupSelect && orderGroupSelect.length > 1
                        ? false
                        : true
                }
                onClick={() => {
                    if (orderGroupSelect.length <= 1) {
                        addToast("ກະລຸນາເລືອກອໍເດີ້ໃດຫນຶ່ງກ່ອນ!", {
                            appearance: "warning",
                            autoDismiss: true,
                        });
                        return;
                    };
                    setIsConfirm(true)
                }}
                style={{
                    display: 'flex', justifyContent: 'start', alignItems: 'center',width:'100%'
                }}
            >
                {
                    jointAllOrderGroupLoading ? (<Spinner animation="border" size="sm" />
                    ) : (
                        <MdChecklist />
                    )
                }
                &nbsp; ລວມອໍເດີທັງຫມົດ
            </Button>

            <ModalConfirmComponent
                showConfirmModal={isConfirm}
                handleCancel={() => setIsConfirm(false)}
                handleConfirm={() => validateJointOrderGroup({ orderGroups: orderGroupSelect })}
                loadingConfirm={jointAllOrderGroupLoading}
                title="ແຈ້ງເຕືອນ"
                // text={"ທ່ານຕ້ອງການລວມອໍເດິ້ນີ້ແທ້ບໍ່!"}
                text={`!!! ທ່ານແນ່ໃຈທີ່ຈະລວມອໍເດີທັງຫມົດບໍ? !!!
            ເພື່ອຄວາມແນ່ໃຈ ກະລຸນາກວດສອບອໍເດີຢ່າງລະອຽດ  ກ່ອນການລວມອໍເດີ
            ຖ້າທ່ານຕ້ອງການລວມອໍເດີທັງຫມົດ ກະລຸນາຄລິກ "ຢືນຢັນ". ຖ້າບໍ່ສາມາດຄລີກ "ຍົກເລີກ".`}
            />
        </>


    );
}

export default BtnJointAllOrderGroup;
